import { Component, Input, OnDestroy, ViewEncapsulation } from "@angular/core";
import { Criterion } from "../models";

@Component({
  selector: "app-general-report",
  templateUrl: "./general-report.component.html",
  // styleUrls: ['./general-report.component.scss']
  encapsulation: ViewEncapsulation.None,
  providers: [],
})
export class GeneralReportComponent {
  @Input() criterions: Criterion[] = [];

  get evaluations() {
    return (
      this.criterions.reduce(
        (acc, currentValue) => acc + currentValue.totalEvaluation || 0,
        0
      ) || 0
    );
  }
}
